export default __webpack_public_path__ + "static/media/Nosotros.08003ced.jpg";